(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'Company', 'Collectivity', 'Profile', 'EquipeCommerciale', 'Principal', 'Division'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, Company, Collectivity, Profile, EquipeCommerciale, Principal, Division) {
        var vm = this;
        if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
            vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT', 'ROLE_DIVISION_ADMIN'];
        } else if (Principal.hasAnyAuthority(['ROLE_DG'])) {
            vm.authorities = ['ROLE_DG', 'ROLE_COMMERCIAL'];
        }



        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
            Division.query().$promise.then(function(divisions) {
                vm.divisions = divisions;
            });
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;

            // En création on initiliser la valeur oauth2 avec la valeur par défaut de l'équipe commerciale
            if (vm.user && !vm.user.id ) {
                if (account.ec && account.ec.oauth2) {
                    vm.user.oauth2 = true;
                } else {
                    vm.user.oauth2 = false;
                }
            }
        });

        vm.initOrganisationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.initProfilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.ecsNoResults = false;
        vm.getEcs = getEcs;
        vm.ecChanged = ecChanged;


        vm.divisionNoResults = false;

        vm.isAdmin = isAdmin;
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function(companies) {
                return Collectivity.search({ query: q }).$promise.then(function(collectivities) {
                    var organizations = companies.concat(collectivities);
                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }

                    vm.initOrganisationsNoResults = organizations.length === 0;
                    vm.editForm.initOrganisation.$setValidity('exist',  organizations.length !== 0);
                    return organizations;
                });
            });
        }


        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function(profiles) {
                vm.initProfilesNoResults = profiles.length === 0;
                vm.editForm.initSuperior.$setValidity('exist',  profiles.length !== 0);
                return profiles;
            });
        }

        function getEcs(q) {
            return EquipeCommerciale.search({ query: q }).$promise.then(function(ecs) {
                vm.ecsNoResults = ecs.length === 0;
                vm.editForm.ec.$setValidity('exist',  ecs.length !== 0);
                return ecs;
            });
        }

        function ecChanged(item) {
            if (item && item.oauth2) {
                vm.user.oauth2 = true;
            } else {
                vm.user.oauth2 = false;
            }
        }
    }
})();
